module.exports = __webpack_public_path__ + "static/media/recipe-hero.79a5a6eb.png";